import { __assign, __rest } from "tslib";
import React, { forwardRef, memo } from 'react';
import clsx from 'clsx';
import { useEventCallback } from '../../../../foundation';
import { StyledYear } from './styles';
import { useScreenReaderContext } from './utils';
var Year = memo(forwardRef(function (props, ref) {
    var onSelect = props.onSelect, value = props.value, selected = props.selected, disabled = props.disabled, focused = props.focused, children = props.children, rest = __rest(props, ["onSelect", "value", "selected", "disabled", "focused", "children"]);
    var getYearAriaLabel = useScreenReaderContext().getYearAriaLabel;
    var _handleClick = useEventCallback(function () { return onSelect(value); });
    var className = clsx({
        'Year-selected': selected,
        'Year-disabled': disabled,
    });
    var yearAriaLabel = getYearAriaLabel === null || getYearAriaLabel === void 0 ? void 0 : getYearAriaLabel("" + value, selected);
    var handleClick = !disabled ? _handleClick : undefined;
    return (React.createElement(StyledYear, __assign({ radius: "round", onClick: handleClick, onKeyPress: handleClick, ref: ref, selected: selected, "aria-pressed": focused, size: "medium", "aria-label": yearAriaLabel, className: className, "data-focusable": selected, "data-test-automation-class": "date-picker-year", "data-test-automation-value": children }, rest),
        React.createElement(React.Fragment, null, 
        // TODO: that <></> will fix when `RcIconButton` ready
        children)));
}));
Year.displayName = 'RcYear';
export { Year };
